import * as React from 'react';
import './PricingCard.css';

interface PricingCardProps {
  title: string;
  price: string;
  features: string[];
  highlight?: boolean;
  selected?: boolean;
  disabled?: boolean;
  onSelect?: () => void;
  hideButton?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  features,
  highlight = false,
  selected = false,
  disabled = false,
  hideButton = false,
  onSelect
}) => {
  return (
    <div className={`pricing-card ${highlight ? 'highlight' : ''} ${selected ? 'selected' : ''}`}>
      <h3>{title}</h3>
      <p className="price">{price}</p>
      <ul>
        {features.map((feature, i) => (
          <li key={i}>{feature}</li>
        ))}
      </ul>
      {!hideButton && (
      <button
        className="select-button"
        disabled={disabled}
        onClick={onSelect}
      >
        {title.toLowerCase() === "enterprise" ? "Contact Us" : "Select"}
      </button>
        )}

</div>
  );
};

export default PricingCard;
